import React, { useContext } from "react";
import PropTypes from "prop-types";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";
import SelectableSection from "./SelectableSection";
import SelectableElement from "./SelectableElement";
import ValuePlaceholder from "./ValuePlaceholder";

const SignatureSectionViewer = ({ invoiceData }) => {
  const { state, showValuePlaceHolder } = useContext(InvoiceTemplateContext);
  const { signatureSection, bilingualEnabled } = invoiceData;

  const { fields } = signatureSection;

  return (
    <SelectableSection
      section="signatureSection"
      isSelectable={signatureSection.isSelectable}
    >
      <table width="100%">
        <tbody>
          <tr>
            {fields
              .filter(field => {
                if (signatureSection.boss.enabled) {
                  return true;
                }
                return !field.isBossSign;
              })
              .filter(field => {
                if (state.invoiceForm === "Conversion") {
                  return true;
                }

                if (state.invoiceForm === "Electronic") {
                  return field.visibleOnInvoiceForm !== "Conversion";
                }
              })
              .map((field, index) => (
                <td key={index} style={{ textAlign: "center" }}>
                  {field.labels.map((labelItem, labelIndex) => (
                    <div key={labelIndex}>
                      <>
                        <SelectableElement
                          as="div"
                          id={`signatureSection.fields[${index}].labels[${labelIndex}].label.vi`}
                          stylePath={`signatureSection.fields[${index}].labels[${labelIndex}].labelStyle.vi`}
                          style={labelItem.labelStyle.vi}
                        >
                          {labelItem.label.vi}
                        </SelectableElement>
                        {bilingualEnabled && (
                          <SelectableElement
                            as="div"
                            id={`signatureSection.fields[${index}].labels[${labelIndex}].label.en`}
                            stylePath={`signatureSection.fields[${index}].labels[${labelIndex}].labelStyle.en`}
                            style={labelItem.labelStyle.en}
                          >
                            {labelItem.label.en}
                          </SelectableElement>
                        )}
                      </>
                    </div>
                  ))}

                  <ValuePlaceholder placeholderKey={field.name}>
                    {field.value}
                  </ValuePlaceholder>
                </td>
              ))}
          </tr>

          <tr>
            {fields
              .filter(field => {
                if (signatureSection.boss.enabled) {
                  return true;
                }
                return !field.isBossSign;
              })
              .filter(field => {
                if (state.invoiceForm === "Conversion") {
                  return true;
                }

                if (state.invoiceForm === "Electronic") {
                  return field.visibleOnInvoiceForm !== "Conversion";
                }
              })
              .map((field, index) => (
                <td key={index} style={{ textAlign: "center" }}>
                  {field.name === "seller_sign" && (
                    <>
                      {!showValuePlaceHolder && (
                        <div className="mt-3">
                          <img style={{width: "200px"}} src={"/seller_sign.png"} />
                        </div>
                      )}
                    </>
                  )}
                </td>
              ))}
          </tr>

          <tr>
            {fields
              .filter(field => {
                if (signatureSection.boss.enabled) {
                  return true;
                }
                return !field.isBossSign;
              })
              .filter(field => {
                if (state.invoiceForm === "Conversion") {
                  return true;
                }

                if (state.invoiceForm === "Electronic") {
                  return field.visibleOnInvoiceForm !== "Conversion";
                }
              })
              .map((field, index) => (
                <td key={index} style={{ textAlign: "center" }}>
                  {field.name === "converter_sign" && (
                    <ValuePlaceholder placeholderKey={"converter_date"}>
                      <div>Ngày chuyển đổi: .../.../...</div>
                    </ValuePlaceholder>
                  )}
                </td>
              ))}
          </tr>
        </tbody>
      </table>
    </SelectableSection>
  );
};

SignatureSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default SignatureSectionViewer;
